import PersonIcon from "@mui/icons-material/Person";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

export default function AppointmentEvent({
  appointment,
  isMonthView,
  reschedule,
  onOnlineAppointmentClick,
}: {
  reschedule?: any;
  appointment: any;
  isMonthView?: boolean;
  onOnlineAppointmentClick?: any;
}) {
  const bgColor =
    appointment?.status === "completed"
      ? "#dc2626"
      : appointment?.color || "#6366f1";
  const isDefault = appointment?.type === "default" && appointment?.type;
  const isOnline = appointment?.type === "online";

  const handleClick = () => {
    if (isOnline && !!onOnlineAppointmentClick && !appointment?.added) {
      onOnlineAppointmentClick(appointment);
    } else {
      reschedule(appointment);
    }
  };

  return (
    <div
      onClick={handleClick}
      className="h-full w-full p-1.5 rounded-lg cursor-pointer transition-all hover:opacity-90 hover:scale-[1.02] overflow-hidden"
      style={{
        backgroundColor: bgColor,
        border: isDefault ? "none" : "2px solid rgba(0,0,0,0.2)",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      <div className="flex flex-col gap-0.5 h-full">
        {/* Patient Name */}
        <div className="flex items-center gap-1">
          <PersonIcon sx={{ fontSize: 12 }} className="text-white/80" />
          <span className="text-xs font-semibold text-white truncate">
            {appointment?.patientName}
          </span>
        </div>

        {/* Doctor Name */}
        <div className="flex items-center gap-1">
          <LocalHospitalIcon sx={{ fontSize: 12 }} className="text-white/80" />
          <span className="text-[10px] text-white/90 truncate">
            {appointment?.dentist}
          </span>
        </div>
      </div>
    </div>
  );
}
